

import util from "../../util";
import current_borrow_icon from "@/assets/img/current_borrow_icon.png"; 
import renew_borrow_icon from "@/assets/img/renew_borrow_icon.png"; 
import history_borrow_icon from "@/assets/img/history_borrow_icon.png"; 
import book_recommod_icon from "@/assets/img/book_recommod_icon.png"; 
import book_recom_icon from "@/assets/img/book_recom_icon.png"; 
import mingshi from "@/assets/img/mingshi.png";
import xuetang from "@/assets/img/xuetang.png";
import yuedu from "@/assets/img/yuedu.png";
import yxuanshu from "@/assets/img/yxuanshu.png";
import zhibo from "@/assets/img/zhibo.png";
import elCard from "@/assets/img/ElECard_icon.png";
import playLogin from "@/assets/img/playLogin_icon.png";
import readingGroup from "@/assets/img/readingGroup.jpg";
import teacherReading from "@/assets/img/teacherReading.jpg";

import BScroll from "better-scroll";
import MyInput from "@/components/SearchInput";
import MyCard from "@/components/Card";
import Swiper from 'vux/src/components/swiper/swiper.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Group from 'vux/src/components/group/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

import Cookies from "js-cookie";
export default {
name: "Home",
directives: {
TransferDom
},
components: {
Swiper,
Flexbox,
FlexboxItem,
Group,
XInput,
XButton,
MyInput,
MyCard,
BScroll,
XDialog
},
data() {
return {
currentToken: "",
bscroll: "",
imgArr: [
{
url: "javascript:",
img: require("../../assets/pics/p1.jpg")
},
{
url: "javascript:",
img: require("../../assets/pics/p2.jpg")
},
{
url: "javascript:",
img: require("../../assets/pics/p3.jpg")
}
],
iconObj: {
current_borrow_icon,
renew_borrow_icon,
history_borrow_icon,
book_recommod_icon,
book_recom_icon,
elCard,
mingshi,
xuetang,
yuedu,
yxuanshu,
zhibo,
playLogin
},
bookdata: [],
isWXClient: util.isWXClient() && Cookies.get("code"),
canRenderSwiper: false,
isShowyunBook: false,
isShowReadingGroup: false,
isShowTeacherReading: false,
isShowTdLive: false,
isShowFreeSchool: false,
showMiniProgram: false,
miniProgramImg: ""
};
},
created() {
this.checkThirdMenu();
this.currentToken = Cookies.get("token");
this.getUserInfo();
},
methods: {
jumpThirdMenu(menu) {
switch (menu) {
case "yunbook":
location.href =
"https://yun.library3.cn/yunbook/#/index" +
"?schoolLink=" +
location.href;
break;
case "readingGroup":
this.showMiniProgram = true;
this.miniProgramImg = readingGroup;
break;
case "teacherReading":
this.showMiniProgram = true;
this.miniProgramImg = teacherReading;
break;
case "tdLive":
location.href = "https://vzan.com/live/livedetail-87382404";
break;
case "freeSchool":
location.href = "https://appjf7ma0tz8012.h5.xiaoeknow.com/";
break;
default:
break;
}
},
checkThirdMenu() {
this.$http("post", "/default/thirdMenu", {})
.then(res => {
if (res.data) {
let data = res.data;
this.isShowyunBook = data.yunBook == "1";
this.isShowReadingGroup = data.readingGroup == "1";
this.isShowTeacherReading = data.teacherReading == "1";
this.isShowTdLive = data.tdLive == "1";
this.isShowFreeSchool = data.freeSchool == "1";
} else {

this.isShowyunBook = false;
this.isShowReadingGroup = false;
this.isShowTeacherReading = false;
this.isShowTdLive = false;
this.isShowFreeSchool = false;
}
})
.catch(err => {

console.log("error:", err);
});
},
initScroll() {
if (!this.bscroll) {
let wrapper = document.querySelector(".c-outer");
this.bscroll = new BScroll(wrapper, {
click: true,
bounce: {
top: false,
bottom: false,
left: false,
right: false
}
});
} else {
this.bscroll.refresh();
}
},
goToSearchPage() {
this.$router.push({
path: "/search"
});
},
getHotBookList() {
this.$http("post", "/book/hot", {
current: 1,
size: 8
})
.then(res => {
try {
sessionStorage.setItem("bscrollY", 0);
} catch (err) {

}
res.data && res.data.forEach(book => {
let bookData = {
bookName: book["ztming"],
isbn: book["isbn"],
marcid: book["marcid"],
infos: [
{
name: "著者",
value: book["zrsming"]
},
{
name: "ISBN",
value: book["isbn"]
},
{
name: "出版社",
value: book["cbzhe"]
},
{
name: "主题",
value: book["zti"]
}
]
};
this.bookdata.push(bookData);
this.$nextTick(() => {
this.bscroll.refresh();
});
});
})
.catch(err => {

console.log("error:", err);
});
},
jumpBookDetail(params, bookdata) {
try {
sessionStorage.setItem("bookInfo", JSON.stringify(bookdata));
} catch (error) {

}
this.$router.push({
path: "/bookDetail",
query: {
isbn: params.isbn,
marcid: params.marcid
}
});
},
handleScanQRCode() {
if (!this.getConfig) {
clearTimeout(this.handletimer);
this.handletimer = setTimeout(() => {
this.handleScanQRCode();
}, 100);
return;
}
let _this = this;

wx.scanQRCode({
needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
scanType: ["qrCode", "barCode"], // 可以指定扫二维码还是一维码，默认二者都有
success: function(res) {
_this.handleScanLogin(res.resultStr);
}
});
},
handleScanLogin(qrCode) {
this.$http("post", "/user/scanLogin", {
qrCode
}).then(res => {

console.log(res);
});
},
jumpToQualityReading() {
if (!Cookies.get("openId")) {
this.$router.push({
path: "/cardBind",
query: {
type: 1
}
});
return;
}
if (!this.readerLoginName) {
this.infoTimer = setInterval(() => {
if (this.readerLoginName) {
clearInterval(this.infoTimer);
location.href = `https://yun.library3.cn/yunbook/#/index?schoolLink=${location.href}&readerLoginName=${this.readerLoginName}&thirdLibraryCode=${this.thirdLibraryCode}&projectConfigCode=${this.projectConfigCode}`;
}
}, 100);
} else {
location.href = `https://yun.library3.cn/yunbook/#/index?schoolLink=${location.href}&readerLoginName=${this.readerLoginName}&thirdLibraryCode=${this.thirdLibraryCode}&projectConfigCode=${this.projectConfigCode}`;
}
},
getUserInfo() {
this.$http("post", "/user/info", {
openId: Cookies.get("openId")
}).then(res => {
if (res.code == 2000) {
return;
}
var reader = res.data[0];
this.readerLoginName = reader["读者证"];
this.thirdLibraryCode = reader["馆编号"];
this.projectConfigCode = Cookies.get("token");
});
},
initWx() {
this.$http("post", "/user/qrCode", {
url: encodeURIComponent(location.href.split("#")[0])
}).then(response => {
let res = response.data;

wx.config({
debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
appId: res.appId, // 必填，公众号的唯一标识
timestamp: res.timestamp, // 必填，生成签名的时间戳
nonceStr: res.nonceStr, // 必填，生成签名的随机串
signature: res.signature, // 必填，签名
jsApiList: ["checkJsApi", "scanQRCode", "hideMenuItems"] 
});
this.getConfig = true;
});
},
setTitle() {
switch (Cookies.get("token")) {
case "tuodi":
document.title = "拓迪书吧";
break;
case "dglgtd":
document.title = "东莞理工学校图书馆";
break;
case "gdfz":
document.title = "广大附中图书馆";
break;
case "xaxg":
document.title = "西安西关第一小学";
break;
default:
document.title = "读者服务";
break;
}
}
},
mounted() {
if (this.isWXClient) {
this.initWx();
}
this.initScroll();
this.getHotBookList();
},
activated() {
this.getUserInfo();
this.setTitle();
this.initScroll();
this.canRenderSwiper = true;
this.bscroll.scrollTo(0, -1);
try {
this.bscroll.scrollTo(
0,
sessionStorage.getItem("bscrollY")
? sessionStorage.getItem("bscrollY") - 0
: 0
);
} catch (error) {

}
},
deactivated() {
try {
sessionStorage.setItem("bscrollY", this.bscroll.y);
} catch (error) {

}
this.canRenderSwiper = false;
}
};
